import { useEffect, useState } from "react";

function readCookie(name) {
  if (typeof document === "undefined") return null;
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

/**
 * Returns the ISO country code the geo-detect edge function set in a
 * cookie, or null until the client has read it (always null during SSR/SSG,
 * since Gatsby's build has no request to inspect).
 *
 * @param {string} cookieName defaults to "geo_country"
 */
export default function useGeoCountry(cookieName = "geo_country") {
  const [country, setCountry] = useState(null);

  useEffect(() => {
    setCountry(readCookie(cookieName));
  }, [cookieName]);

  return country;
}
